<template>
  <exercicioPergunta :alternativas="alternativas"></exercicioPergunta>
</template>

<script>
import exercicioPergunta from '@/custom/exercicioPergunta'
var componentDefinition = {
  components: { exercicioPergunta },
  route: {
    name: 'QUESTOES-PERGUNTA',
    path: '/aluno/:idaluno/matricula/:idmatricula/bloco/:idbloco/questoes/rodada/:rodada/pergunta/:refresh?',
    meta: {
      title: 'Questões',
      hasErrorHandler: true,
      pergunta: true,
      hidden: true
    }
  },
  computed: {
    alternativas: function () {
      var alternativas = []
      if (this.$dados.PERGUNTA.ALTERNATIVAS) {
        this.$dados.PERGUNTA.ALTERNATIVAS.map((title, index) => {
          alternativas.push({
            title: title,
            resposta: index + 1
          })
        })
      }
      return alternativas
    }
  }
}
export default componentDefinition
</script>
